import {
  Box,
  Container,
  Heading,
  SimpleGrid,
  Text,
  useColorModeValue,
  Badge,
  VStack,
  HStack,
  Icon,
  Button,
} from '@chakra-ui/react';
import { CheckIcon } from '@chakra-ui/icons';
import { plans } from '../hooks/plans';
import { useNavigate } from 'react-router-dom';
import Footer from '../components/layout/footer';

const TrialAndSubscriptionPage = () => {
  const plansData = plans;
  const green = '#009800ff';
  const bg = useColorModeValue('white', 'gray.800');
  const cardBorder = useColorModeValue('gray.200', 'gray.600');
  const textColor = useColorModeValue('gray.700', 'gray.200');
  const subTextColor = useColorModeValue('gray.500', 'gray.400');

  const navigate = useNavigate();

  return (
    <Box
      bg={useColorModeValue('gray.50', 'gray.900')}
      minH="100vh"
      py={16}
      flexDirection={'column'}
    >
      <Container maxW="7xl">
        {/* Header */}
        <VStack spacing={4} textAlign="center" mb={12}>
          <Heading size="2xl" fontWeight="bold" color={green}>
            Choose the Perfect Plan
          </Heading>
          <Text fontSize="lg" color={subTextColor} maxW="2xl">
            Flexible pricing designed to grow with your business. Upgrade,
            downgrade, or cancel anytime - no hidden fees, just great value.
          </Text>
        </VStack>

        {/* Plans */}
        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={10}>
          {plansData.map((plan, idx) => (
            <Box
              key={idx}
              p={8}
              rounded="2xl"
              bg={bg}
              borderWidth="2px"
              borderColor={plan.isCurrent ? green : cardBorder}
              boxShadow={plan.isCurrent ? '2xl' : 'md'}
              transition="all 0.3s"
              _hover={{
                transform: 'translateY(-8px)',
                boxShadow: 'xl',
              }}
              position="relative"
            >
              <HStack mb={4} justify="space-between">
                <Heading size="lg" color={green}>
                  {plan.name}
                </Heading>
                {plan.isCurrent && (
                  <Badge
                    colorScheme="green"
                    fontSize="xs"
                    px={3}
                    py={1}
                    rounded="full"
                    textTransform="uppercase"
                  >
                    Current Plan
                  </Badge>
                )}
              </HStack>

              <Text
                fontSize="4xl"
                fontWeight="bold"
                color={textColor}
                mt={2}
                mb={1}
              >
                {plan.price}
              </Text>
              <Text fontSize="sm" color={subTextColor} mb={2}>
                Excl. VAT
              </Text>
              <Text fontSize="sm" color={subTextColor} mb={6}>
                {plan.users}
              </Text>

              <VStack align="start" spacing={3} mb={8}>
                {plan.features.map((feature, i) => (
                  <HStack key={i} align="start">
                    <Icon as={CheckIcon} boxSize={4} color={green} mt={1} />
                    <Text fontSize="sm" color={textColor}>
                      {feature}
                    </Text>
                  </HStack>
                ))}
              </VStack>

              {/* CTA Button */}
              <Button
                w="full"
                size="lg"
                bgColor={green}
                color="white"
                _hover={{ bg: 'green.700' }}
                borderRadius="lg"
                onClick={() => navigate('/sign-up')}
              >
                {plan.isCurrent ? 'Manage Plan' : 'Get Started'}
              </Button>
            </Box>
          ))}
        </SimpleGrid>
      </Container>
      <Footer />
    </Box>
  );
};

export default TrialAndSubscriptionPage;
